import { BrowserRouter, Routes, Route } from 'react-router-dom';

import Login from './pages/Auth/Login';
import Lock from './pages/Auth/Lock';

import Profile from './pages/Profile';
import Dashboard from './pages/Dashboard';

import NoPage from './pages/NoPage';

import Layout from './layouts/Layout';
import LoginLayout from './layouts/LoginLayout';

import ROUTES from './routes';
import PublicRoute from './PublicRoute';
import ProtectedRoute from './ProtectedRoute';

import ForgotPwd from './pages/Auth/ForgotPwd';
import ResetPwd from './pages/Auth/ResetPwd';
import EmailVerify from './pages/EmailVerify';

import Agents from './pages/Agents/Agents';
import AddAgent from './pages/Agents/AddAgent';
import EditAgent from './pages/Agents/EditAgent';

import Brands from './pages/Brands/Brands';
import AddBrand from './pages/Brands/AddBrand';
import EditBrand from './pages/Brands/EditBrand';

import Categories from './pages/Categories/Categories';
import AddCategory from './pages/Categories/AddCategory';
import EditCategory from './pages/Categories/EditCategory';

import Products from './pages/Products/Products';
import AddProduct from './pages/Products/AddProduct';
import EditProduct from './pages/Products/EditProduct';

import Testimonials from './pages/Testimonials/Testimonials';
import AddTestimonial from './pages/Testimonials/AddTestimonial';
import EditTestimonial from './pages/Testimonials/EditTestimonial';

import Warehouse from './pages/Warehouse/Warehouse';
import AddWarehouse from './pages/Warehouse/AddWarehouse';
import EditWarehouse from './pages/Warehouse/EditWarehouse';

import Blogs from './pages/Blogs/Blogs';
import AddBlog from './pages/Blogs/AddBlog';
import EditBlog from './pages/Blogs/EditBlog';

import CMSWrapper from './pages/CMS/CMSWrapper';
import GeneralSettings from './pages/Settings/GeneralSettings';

import Faq from './pages/Faq/Faq';
import AddFaq from './pages/Faq/AddFaq';
import EditFaq from './pages/Faq/EditFaq';

import Leads from './pages/Leads/Leads';
import CtaRequests from './pages/Cta/Cta';
import TradeAccounts from './pages/TradeAccounts/TradeAccounts';
import Orders from './pages/Orders/Orders';
import OrderDetail from './pages/Orders/OrderDetail';
import PaymentLinks from './pages/PaymentLinks/PaymentLinks';
import AddPaymentLink from './pages/PaymentLinks/AddPaymentLink';

import Reviews from './pages/Reviews/Reviews';

export default function App() {
  return (
    <BrowserRouter>
      <Routes>

        {/* Public Routes */}
        <Route path={ROUTES.AUTH} element={<LoginLayout />}>
          <Route
            path={ROUTES.LOGIN}
            element={
              <PublicRoute>
                <Login />
              </PublicRoute>
            }
          />
          <Route path={ROUTES.LOCK} element={<Lock />} />
          <Route path={ROUTES.FORGOTPWD} element={<ForgotPwd />} />
          <Route path={ROUTES.RESETPWD} element={<ResetPwd />} />
        </Route>

        {/* Protected Routes */}
        <Route
          path={ROUTES.ROOT}
          element={
            <ProtectedRoute>
              <Layout />
            </ProtectedRoute>
          }
        >
          <Route index element={<Dashboard />} />
          <Route path={ROUTES.PROFILE} element={<Profile />} />

          <Route path={ROUTES.AGENTS} element={<Agents />} />
          <Route path={ROUTES.ADD_AGENT} element={<AddAgent />} />
          <Route path={ROUTES.EDIT_AGENT} element={<EditAgent />} />

          <Route path={ROUTES.WAREHOUSE} element={<Warehouse />} />
          <Route path={ROUTES.ADD_WAREHOUSE} element={<AddWarehouse />} />
          <Route path={ROUTES.EDIT_WAREHOUSE} element={<EditWarehouse />} />

          <Route path={ROUTES.BRANDS} element={<Brands />} />
          <Route path={ROUTES.ADD_BRAND} element={<AddBrand />} />
          <Route path={ROUTES.EDIT_BRAND} element={<EditBrand />} />

          <Route path={ROUTES.CATEGORIES} element={<Categories />} />
          <Route path={ROUTES.ADD_CATEGORY} element={<AddCategory />} />
          <Route path={ROUTES.EDIT_CATEGORY} element={<EditCategory />} />

          <Route path={ROUTES.PRODUCTS} element={<Products />} />
          <Route path={ROUTES.ADD_PRODUCT} element={<AddProduct />} />
          <Route path={ROUTES.EDIT_PRODUCT} element={<EditProduct />} />

          <Route path={ROUTES.TESTIMONIALS} element={<Testimonials />} />
          <Route path={ROUTES.ADD_TESTIMONIAL} element={<AddTestimonial />} />
          <Route path={ROUTES.EDIT_TESTIMONIAL} element={<EditTestimonial />} />

          <Route path={ROUTES.BLOGS} element={<Blogs />} />
          <Route path={ROUTES.ADD_BLOG} element={<AddBlog />} />
          <Route path={ROUTES.EDIT_BLOG} element={<EditBlog />} />

          <Route path={ROUTES.FAQ} element={<Faq />} />
          <Route path={ROUTES.ADD_FAQ} element={<AddFaq />} />
          <Route path={ROUTES.EDIT_FAQ} element={<EditFaq />} />
          <Route path={ROUTES.CMS} element={<CMSWrapper />} />

          <Route path={ROUTES.LEADS} element={<Leads />} />
          <Route path={ROUTES.CTA} element={<CtaRequests />} />
          <Route path={ROUTES.TRADE_ACCOUNTS} element={<TradeAccounts />} />

          <Route path={ROUTES.REVIEW} element={<Reviews />} />

          <Route path={ROUTES.ORDERS} element={<Orders />} />
          <Route path={ROUTES.ORDER_DETAIL} element={<OrderDetail />} />
          <Route path={ROUTES.PAYMENT_LINKS} element={<PaymentLinks />} />
          <Route path={ROUTES.ADD_PAYMENT_LINK} element={<AddPaymentLink />} />

          <Route path={ROUTES.SETTINGS_GENERAL} element={<GeneralSettings />} />

          <Route path={ROUTES.VERIFY_EMAIL} element={<EmailVerify />} />
        </Route>

        {/* 404 */}
        <Route path="*" element={<NoPage />} />
      </Routes>
    </BrowserRouter>
  );
}
